import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCloseQuote2: React.FC<CentralIconBaseProps> = (props) => {
  return (
    <CentralIconBase {...props} ariaLabel="close-quote-2, blockquote">
      <path
        d="M7 5H6C4.34315 5 3 6.34315 3 8V10.2308C3 11.7602 4.23983 13 5.76923 13C5.89668 13 6 13.1033 6 13.2308V19C6 19 10 17.5 10 13V7.99901C10 6.34216 8.65685 5 7 5Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M18 5H17C15.3431 5 14 6.34315 14 8V10.2308C14 11.7602 15.2398 13 16.7692 13C16.8967 13 17 13.1033 17 13.2308V19C17 19 21 17.5 21 13V7.99901C21 6.34216 19.6569 5 18 5Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </CentralIconBase>
  );
};

export default IconCloseQuote2;
